module.exports = __webpack_public_path__ + "fonts/8b383d596e219544c421e88a25ff50d9.svg";